'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Children, isValidElement, cloneElement } from 'react';
import { tokensRaw } from '../../../core/tokens/tokens-raw.js';
import { ThumbnailsHeroVideoThumbnailSlide } from './thumbnails-hero-video-thumbnail-slide.component.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { ThumbnailsHeroBackgroundContainer } from './thumbnails-hero-background-container.component.js';
import { ThumbnailsHeroContentContainer } from './thumbnails-hero-content-container.component.js';
import { ThumbnailsHeroImagesSlidesContainer } from './thumbnails-hero-images-slides-container.component.js';
import { ThumbnailsHeroThumbnailsSlidesContainer } from './thumbnails-hero-thumbnails-slides-container.component.js';
import { Carousel } from '../carousel/carousel.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { CarouselSlide } from '../carousel/carousel-slide.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, o) {
    if (null == e) return {};
    var r, t, n = _object_without_properties_loose(e, o);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(t = 0; t < s.length; t++)r = s[t], !(o.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, o) {
    if (null == e) return {};
    var r, t, n = {}, s = Object.keys(e);
    for(t = 0; t < s.length; t++)r = s[t], o.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const ThumbnailsHero = renderWithRef('ThumbnailsHero', null, (c, w)=>{
    useComponentStylesLoaded('ThumbnailsHero', SWAN_STYLE_KEY_MAP.thumbnailsHero);
    let { currentSlide: g = 0, accessibleTextForDots: _, onSlideChange: k, children: y } = c, j = _object_without_properties(c, [
        "currentSlide",
        "accessibleTextForDots",
        "onSlideChange",
        "children"
    ]), x = [], S = [], v = null, T = null;
    return Children.forEach(y, (e)=>{
        if (isValidElement(e)) switch(e.type){
            case ThumbnailsHeroThumbnailsSlidesContainer:
                x.push(...Children.map(e.props.children, (e, o)=>[
                        CarouselSlide,
                        ThumbnailsHeroVideoThumbnailSlide
                    ].includes(e.type) ? cloneElement(e, {
                        key: o,
                        component: e.props.component || 'span'
                    }) : null));
                break;
            case ThumbnailsHeroImagesSlidesContainer:
                S.push(...Children.map(e.props.children, (e, o)=>e.type === CarouselSlide ? cloneElement(e, {
                        key: o
                    }) : null));
                break;
            case ThumbnailsHeroBackgroundContainer:
                v = e;
                break;
            case ThumbnailsHeroContentContainer:
                T = e;
        }
    }), jsxs(RenderComp, {
        root: "div",
        forwardedRef: w,
        classNames: new Set([
            'swan-thumbnails-hero'
        ]),
        props: j,
        children: [
            v,
            jsx("div", {
                className: "swan-thumbnails-hero-images-carousel-container",
                children: jsx(Carousel, {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    arrows: false,
                    accessibleTextForNext: "",
                    accessibleTextForPrevious: "",
                    accessibleTextForDots: _,
                    customPaging: (o)=>jsx("button", {
                            "aria-label": _[o],
                            children: x[o]
                        }, o),
                    progressIndicator: 'dots',
                    progressIndicatorAlignment: 'left',
                    currentSlide: null != g ? g : 0,
                    beforeChange: null != k ? k : void 0,
                    fade: true,
                    responsive: [
                        {
                            breakpoint: parseInt(tokensRaw.SwanBaseBreakpointMdStart, 10),
                            settings: {
                                fade: false
                            }
                        }
                    ],
                    children: S
                })
            }),
            T
        ]
    });
});

export { ThumbnailsHero };
